export default __webpack_public_path__ + "static/media/prdnewsimg2.358a6e56.svg";